<!--
 * @Author: weijinpeng jinpeng.wei@ctx.sg
 * @LastEditors: weijinpeng jinpeng.wei@ctx.sg
 * @Date: 2023-03-03 14:26:02
 * @LastEditTime: 2023-03-10 15:31:27
 * @Description: 
-->
<template>
    <!-- Credit in IOP Registry -->
    <div>
        <div class="title">Credits in IOP Registry</div>

        <!-- 搜索 -->
        <div class="search">
            <el-row :gutter="20" type="flex" align="bottom">
                <el-col :span="8">
                    <div class="search_t">ID</div>
                    <el-input v-model="fromData.projectId" clearable placeholder="Project ID"></el-input>
                </el-col>
                <el-col :span="8">
                    <div class="search_t">Status</div>
                    <el-select v-model="fromData.projectSector" style="width:100%" clearable  placeholder="All">
                        <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="8">
                    <div class="search_btn">Search</div>
                </el-col>
            </el-row>
        </div>

        <!-- 表格 -->
        <div class="mg_t_50">
            <el-table
                :data="tableData.slice((currentPage - 1) * pageSize,currentPage * pageSize)"
                stripe
                :cell-style="columnStyle"
                style="width: 100%"
                :header-cell-style="{
                  background: '#F0F3F6',
                  color: '#626262',
                  fontSize: '12px',
                  paddingTop: '17px',
                  paddingBottom: '15px',
                }"
            >
                <!-- 空状态 -->
                <template slot="empty">
                  <p style="margin-top: 50px">
                    <img class="data-pic" src="../../assets/img/noData.png" alt=""/>
                  </p>
                </template>
                <el-table-column prop="id" label="ID">
                    <template  slot-scope="scope">
                        <div class="t_p" @click="gotoDetail(scope.row)">{{ scope.row.id }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="projectName" label="Project Name">
                    <template  slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="scope.row.projectName" placement="bottom">
                            <div class="t_txt">{{ scope.row.projectName }}</div>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="vintage" label="Vintage"></el-table-column>
                <el-table-column prop="date" label="Date of Retirement"></el-table-column>
                <el-table-column prop="status" label="Credit Status"></el-table-column>
                <el-table-column prop="quantity" label="Carbon Credit Quantity"></el-table-column>
            </el-table>
            <div class="display_flex" style="margin-top: 47px">
                <el-pagination
                  v-if="tableData.length != 0"
                  @current-change="handleCurrentChange"
                  :page-size="pageSize"
                  background
                  layout="prev, pager, next"
                  class="pagination"
                  prev-text="<"
                  next-text=">"
                  :total="tableData.length"
                >
                </el-pagination>
            </div>
        </div>
    </div>

</template>
  
<script>
import carbonRegistry from "@/api/carbonRegistry.js";
export default {
    name: 'carboncredit',
    components: {
    },
    data(){
      return {
        fromData:{
            projectId:"",
            projectSector:"",
            status:"",
            operator:"",
            date:'',
        },
        fromData1:{
            region:"",
            projectSector:"",
            projectId:"",
        },
        projectSectorList:[],
        statusList:[
            {
                value: '1',
                label: 'Active'
            },
            {
                value: '2',
                label: 'Transferred'
            },
            {
                value: '3',
                label: 'Retired'
            },
            {
                value: '4',
                label: 'Cancelled'
            },
        ],
        tableData:[
            {
                id:'19584',
                date:"2022/12/21",
                status:"Active",
                projectName:"Gianyar Waste Recovery Project",
                vintage:"2021/12-2022/12",
                quantity:"35,000",
            },
            {
                id:'65813',
                date:"2022/12/21",
                status:"Transferred",
                projectName:"Luyi Biogas Recovery and Utilization Project",
                vintage:"2021/12-2022/12",
                quantity:"46,500",
            },
            {
                id:'96584',
                date:"2022/12/21",
                status:"Retired",
                projectName:"Recyling Used Cooking Oil into Biodiesel in Bali",
                vintage:"2021/12-2022/12",
                quantity:"33,500",
            },
            {
                id:'96548',
                date:"",
                status:"Cancelled",
                projectName:"Huaxian Caiying Biogas Recovery and Utilization Project",
                vintage:"2021/12-2022/12",
                quantity:"39,500",
            },
            {
                id:'63251',
                date:"",
                status:"Cancelled",
                projectName:"Macaúbas Landfill Gas Project",
                vintage:"2021/12-2022/12",
                quantity:"37,800",
            },
        ],
        pageSize: 10,
        currentPage: 1,
        requestBool:false,
        upload_dia:false,
        login:{},
        upload:{},
        fileList: [],
      }
    },
    created(){
        this.login = JSON.parse(sessionStorage.getItem('login'))
    },
    mounted(){
        this.getProjectType()
    },
    methods:{
        columnStyle({ row, column, rowIndex, columnIndex}){
            if(columnIndex == 1){
                return "color:#366F67;word-break:break-word;";
            }
            return "word-break:break-word;";
        },
        gotoDetail(row){
            this.$router.push({
                path:'/carbonDetail2',
                query:{
                    id:row.id
                },
            })
        },
        //翻页
        handleCurrentChange(updateCurrentPage) {
            this.currentPage = updateCurrentPage;
        },
        getProjectType() {
            carbonRegistry.getProjectType((res) => {
                this.projectSectorList = res.list;
            },{country:this.login.country});
        },
        changeRequestBool(){
            this.requestBool = true
        },
        cancelRequestBool(){
            this.requestBool = false
        },
        confirmRequestBool(){
            this.requestBool = false
        },
        changeUploadDia(){
            this.upload_dia = true
        },

        // 上传
        beforeRemove(file) {},
        // 上传成功
        handleSuccess(file) {
            console.log('上传成功',file)
        },
        beforeUpload(file) {           
            console.log(file)           
            // var testmsg=file.name.substring(file.name.lastIndexOf('.')+1) 
            // console.log(testmsg)                       
            // const extension = testmsg === 'jpg'            
            // const extension2 = testmsg === 'png'
            // const extension3 = testmsg === 'gif'
            // const extension4 = testmsg === 'svg'  
            // const extension5 = testmsg === 'jpeg'            
            const isLt2M = file.size / 1024 / 1024 < 3          
            // if(!extension && !extension2 && !extension3 && !extension4 && !extension5) {                
            //     this.$message({                    
            //         message: '上传文件只能是 jpg、jpeg、png、gif、svg格式!',                    
            //         type: 'warning'               
            //     });            
            // } 
            if(!isLt2M) {           
                this.$message({           
                    message: 'File Support size: 3MB',            
                    type: 'warning'            
                });           
            }    
            return isLt2M                  
            // return (extension || extension2 || extension3 || extension4 || extension5) && isLt2M      
        },
    },
}
</script>
  
<style lang="scss" scoped>
.mg_t_40{
    margin-top:40px;
}
.mg_t_50{
    margin-top:50px;
}
.title{
    font-size: 30px;
    font-weight: 600;
    color: #1E1E1E;
    line-height: 34px;
}
.search{
    margin-top:50px;
    .search_t{
        font-size: 14px;
        font-weight: 600;
        color: #21212B;
        line-height: 16px;
        margin-bottom:10px;
    }
    .search_btn{
        width: 130px;
        height: 38px;
        border-radius: 8px;
        border: 1px solid #158869;
        font-size: 16px;
        color: #158869;
        line-height: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
}
.img{
    width: 15px;
    height: 16px;
}
.flex{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin:50px 0 15px 0; 
}
.display_flex{
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
.flex_w{
    display: flex;
    align-items: center;
    .f_t{
        font-size: 14px;
        color: #158869;
        line-height: 16px;
        cursor: pointer;
        margin-left: 8px;
    }
}
.data-pic {
    width: 244px;
    height: 210px;
}
.nodata {
    font-size: 16px;
    font-family: ArialMT;
    color: #626262;
}
.t_txt{
    color: #158869;
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.t_p{
    font-size: 16px;
    font-family: ArialMT;
    color: #013C89;
    cursor: pointer;
}
.w_130{
    max-width: 130px;
}
.w_100{
    max-width: 100px;
}
.w_120{
    max-width: 120px;
}


.top{
    width: calc(100% - 60px);
    height: 80px;
    background: #e1eeeb;
    border-radius: 8px;
    padding: 0 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .top_h3{
        font-size: 16px;
        color: #626262;
        line-height: 18px;
    }
    .top_h2{
        font-size: 30px;
        font-weight: 600;
        color: #000000;
        line-height: 34px;
    }
}
.d_t{
    font-size: 30px;
    font-family: Arial-BoldMT, Arial;
    font-weight: 600;
    color: #1E1E1E;
    line-height: 34px;
    margin-top:50px;
}
.wd_90{
    width: 90px !important;
}
.mg_t_50{
    margin-top: 50px;
}
.action_btn{
    font-size: 16px;
    font-family: ArialMT;
    color: #158869;
    cursor: pointer;
}
.action_btn_r{
    font-size: 16px;
    font-family: ArialMT;
    color: #ED6666;
    cursor: pointer;
}
.banner{
    padding:20px;
    .tlt{
        text-align: center;
        font-size: 20px;
        font-family: Arial-BoldMT, Arial;
        font-weight: 600;
        color: #21212B;
        line-height: 28px;
        margin-bottom:30px;
    }
    .t2t{
        font-size: 14px;
        font-family: Arial-BoldMT, Arial;
        font-weight: 600;
        color: #21212B;
        line-height: 16px;
        margin-bottom:12px;
    }
    .btn{
        margin: 30px auto auto auto;
        width: 125px;
        height: 44px;
        background: #158869;
        border-radius: 4px;
        display:flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        font-family: ArialMT;
        color: #FFFFFF;
        line-height: 18px;
    }
}
.tb_btm{
    width: calc(100% - 40px);
    height: 50px;
    background: #FFFFFF;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding:0 20px;
    font-size: 20px;
    font-family: Arial-BoldMT, Arial;
    font-weight: 600;
    color: #1E1E1E;
    line-height: 23px;
}
.tb_2{
    margin-top: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .h2{
        font-size: 30px;
        font-family: Arial-BoldMT, Arial;
        font-weight: 600;
        color: #1E1E1E;
        line-height: 34px;
    }
    .felx{
        display: flex;
        align-items: center;
        cursor: pointer;
        .img{
            width:20px;
            height:20px;
        }
        .h3{
            font-size: 14px;
            font-family: ArialMT;
            color: #158869;
            line-height: 16px;
            margin-left: 8px;
        }
    }
}
.btm_btn{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top:50px;
    .flex{
        display: flex;
        align-items: center;
        .can_btn{
            width: 110px;
            height: 38px;
            border-radius: 8px;
            border: 1px solid #158869;
            font-size: 16px;
            font-family: ArialMT;
            color: #158869;
            line-height: 18px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .con_btn{
            width: 110px;
            height: 40px;
            background: #158869;
            border-radius: 8px;
            font-size: 16px;
            font-family: ArialMT;
            color: #FFFFFF;
            line-height: 18px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: 20px;
        }
    }
}
.dia_banner{
    width: 750px;
    .diaerrimg{
        width:52px;
        height:52px;
        margin: 0 auto;
        display: flex;
    }
    .tlt{
        font-size: 20px;
        font-family: ArialMT;
        color: #626262;
        line-height: 23px;
        text-align: center;
        margin-top: 20px;
        margin-bottom:50px;
    }
    .f_t{
        font-size: 14px;
        font-family: Arial-BoldMT, Arial;
        font-weight: 600;
        color: #21212B;
        line-height: 16px;
        margin-bottom:12px;
    }
    .mg_t_40{
        margin-top:40px;
    }
}
.upload_box{
    width:748px;
    height:222px;
    border:1px dashed #CCD2DA;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img{
        width:48px;
        height: 48px;
    }
}
.up_btn{
    margin: 50px auto;
    width: 125px;
    height: 44px;
    background: #158869;
    border-radius: 4px;
    font-size: 16px;
    font-family: ArialMT;
    color: #FFFFFF;
    line-height: 18px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}
::v-deep .btm_dia_up{
    .el-dialog{
        margin-top: 15vh !important;
    }
}
::v-deep .upload{
    .el-icon-close:before{
        content: "\e6db" !important;
    }
}
</style>
  